import CampoTexto from '../../components/Formulario/CampoTexto';
import CampoData from '@/components/Formulario/CampoData';
import CampoMemo from '@/components/Formulario/CampoMemo';
import CampoDinheiro from '@/components/Formulario/CampoDinheiro';
import CampoNumero from '@/components/Formulario/CampoNumero';
import CampoSeletor from '../../components/Formulario/CampoSeletor';
import Grid, { GridItem } from '../../components/layout/Grid';
import { useQuery } from 'react-query';
import axios from 'axios';

const tipoOptions = [
  { id: 'receita', label: 'Receita' },
  { id: 'despesa', label: 'Despesa' },
];

const frequenciaOptions = [
  { id: 'semanal', label: 'Semanal' },
  { id: 'mensal', label: 'Mensal' },
  { id: 'trimestral', label: 'Trimestral' },
  { id: 'semestral', label: 'Semestral' },
  { id: 'anual', label: 'Anual' },
];

export const FormRecorrencia = ({
  value,
  onChange,
  fieldErrors,
}: {
  value: any;
  onChange: any;
  fieldErrors: any;
}) => {
  const tipo = value?.tipo ?? 'despesa';

  const qCategorias = useQuery(
    ['categoria_financeira/box', tipo],
    async () => {
      const res = await axios.get('/api/categoria_financeira/box', {
        params: { tipo },
      });
      return res.data;
    },
  );
  const categoriasOptions =
    qCategorias.data?.result?.map((it: any) => ({
      id: it.id,
      label: it.nome,
    })) ?? [];

  const qCentrosCusto = useQuery('centro_custo/box', async () => {
    const res = await axios.get('/api/centro_custo/box');
    return res.data;
  });
  const centrosCustoOptions =
    qCentrosCusto.data?.result?.map((it: any) => ({
      id: it.id,
      label: it.nome,
    })) ?? [];

  // A "próxima ocorrência" é o cursor interno do job de geração — ao criar do
  // zero (sem passar por "transformar em recorrência"), a primeira ocorrência
  // ainda não existe, então ela nasce igual à data de início.
  const onChangeDataInicio = (data_inicio: string) => {
    const next: any = { ...value, data_inicio };
    if (!value?.id) {
      next.proxima_data_vencimento = data_inicio;
    }
    onChange(next);
  };

  return (
    <Grid>
      <GridItem sm={12} md={4}>
        <CampoSeletor
          noSearch
          instanceId="tipo"
          value={tipo}
          onChange={v => onChange({ ...value, tipo: v, id_categoria: null })}
          label="Tipo"
          options={tipoOptions}
          error={fieldErrors?.tipo}
        />
      </GridItem>
      <GridItem sm={12} md={8}>
        <CampoTexto
          instanceId="descricao"
          value={value?.descricao ?? ''}
          onChange={v => onChange({ ...value, descricao: v })}
          label="Descrição"
          error={fieldErrors?.descricao}
        />
      </GridItem>
      <GridItem sm={12} md={4}>
        <CampoDinheiro
          instanceId="valor"
          value={value?.valor ?? 0}
          onChange={v => onChange({ ...value, valor: v })}
          label="Valor"
          error={fieldErrors?.valor}
        />
      </GridItem>
      <GridItem sm={12} md={4}>
        <CampoSeletor
          noSearch
          instanceId="frequencia"
          value={value?.frequencia ?? 'mensal'}
          onChange={v => onChange({ ...value, frequencia: v })}
          label="Frequência"
          options={frequenciaOptions}
          error={fieldErrors?.frequencia}
        />
      </GridItem>
      <GridItem sm={12} md={4}>
        <CampoNumero
          instanceId="dias_antecedencia_geracao"
          value={value?.dias_antecedencia_geracao ?? 30}
          onChange={v => onChange({ ...value, dias_antecedencia_geracao: v })}
          label="Dias de antecedência"
          error={fieldErrors?.dias_antecedencia_geracao}
          append={<span>dias antes do vencimento</span>}
        />
      </GridItem>
      <GridItem sm={12} md={6}>
        <CampoData
          instanceId="data_inicio"
          type="date"
          value={value?.data_inicio ?? ''}
          onChange={onChangeDataInicio}
          label="Início"
          error={fieldErrors?.data_inicio}
        />
      </GridItem>
      <GridItem sm={12} md={6}>
        <CampoData
          instanceId="data_fim"
          type="date"
          value={value?.data_fim ?? ''}
          onChange={v => onChange({ ...value, data_fim: v || null })}
          label="Fim (opcional)"
          error={fieldErrors?.data_fim}
        />
      </GridItem>
      <GridItem sm={12} md={6}>
        <CampoSeletor
          nullable
          instanceId="id_categoria"
          value={value?.id_categoria ?? null}
          onChange={v => onChange({ ...value, id_categoria: v })}
          label="Categoria"
          placeholder="(Sem categoria)"
          error={fieldErrors?.id_categoria}
          options={categoriasOptions}
        />
      </GridItem>
      <GridItem sm={12} md={6}>
        <CampoSeletor
          nullable
          instanceId="id_centro_custo"
          value={value?.id_centro_custo ?? null}
          onChange={v => onChange({ ...value, id_centro_custo: v })}
          label="Centro de custo"
          placeholder="(Sem centro de custo)"
          error={fieldErrors?.id_centro_custo}
          options={centrosCustoOptions}
        />
      </GridItem>
      <GridItem sm={12}>
        <CampoMemo
          instanceId="obs"
          value={value?.obs ?? ''}
          onChange={v => onChange({ ...value, obs: v })}
          label="Observações"
          error={fieldErrors?.obs}
        />
      </GridItem>
    </Grid>
  );
};
